<template>
  <div class="ei-input">
    <div class="input-data">
      <input :type="type" required v-model="value" :aria-placeholder="tip"/>
      <div class="underline"></div>
      <label>{{label}}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: "EiInput",
  props:{
    type:{
      default:'text'
    },
    value:{
      required:true
    },
    label:{
      required:true
    },
    tip:{
      required:false
    }
  }
}
</script>

<style scoped lang="scss">
.ei-input{
  width: 95%;
  background: #fff;
  padding: 30px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

.ei-input .input-data{
  position: relative;
  height: 40px;
  width: 100%;
}

.ei-input .input-data input{
  height: 100%;
  width: 100%;
  border : none;
  font-size: 17px;
  padding-top: 14px;
  border-bottom: 2px solid silver;
}
.input-data input:focus{
  outline: none;
}
.input-data input:focus ~ label,
.input-data input:valid ~ label{
  transform: translateY(-20px);
  font-size: 15px;
  color: #4158d0;
}

.ei-input .input-data label{
  position: absolute;
  bottom: 10px;
  left: 0;
  color: grey;
  pointer-events: none;
  transition: all 0.3s ease;
}

.ei-input .input-data .underline{
  position: absolute;
  left: 0;
  bottom: 0;
  height: 2px;
  width: 100%;
}

.input-data .underline:before{
  position: absolute;
  content: "";
  height: 100%;
  width: 100%;
  left: 0;
  background: #4158d0;
  transform: scaleX(0);
  transition: transform 0.5s ease;
}

.input-data input:focus ~ .underline:before,
.input-data input:valid ~ .underline:before{
  transform: scaleX(1);
}
</style>
